module.exports = __webpack_public_path__ + "img/img_zixun.76cad352.png";